var React = require('react');

function Q2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Q2"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("path",{"d":"M65.6,17.25A39.1,39.1,0,0,0,15.85,4.06L58.43,68.94A39.1,39.1,0,0,0,65.6,17.25Z","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("path",{"d":"M75.24,76.54l-33-32.79h0L9.32,10.86l-.59.72a40,40,0,0,0,33.5,64.9v.06Z","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

Q2.defaultProps = {"viewBox":"0 0 75.24 76.54"};

module.exports = Q2;

Q2.default = Q2;
